import {
  BlockedUpgrade,
  DeviceConfiguration,
  ForcedUpgrade,
  ForceUpgradeConfiguration,
  ForceUpgradeType,
  SkippableUpgrade,
} from './types';

export function getForceUpgradeLanguage(configuration: DeviceConfiguration) {
  return configuration.forceUpgrade?.languageCode;
}

export function getPersonalListType(configuration: DeviceConfiguration) {
  return configuration.personalLists?.userPersonalLineup;
}

export function isForceUpgradeEnabled({
  brandId,
  configuration,
}: {
  configuration: DeviceConfiguration;
  brandId: number;
}) {
  if (!configuration.forceUpgrade) {
    return false;
  }

  const { enabled, brands } = configuration.forceUpgrade;

  return enabled && (brands.blocked.has(brandId) || brands.forced.has(brandId) || brands.skippable.has(brandId));
}

export function isBlockedUpgrade(configuration: ForceUpgradeConfiguration): configuration is BlockedUpgrade {
  return configuration.type === ForceUpgradeType.Blocked;
}

export function isForcedUpgrade(configuration: ForceUpgradeConfiguration): configuration is ForcedUpgrade {
  return configuration.type === ForceUpgradeType.Forced;
}

export function isSkippableUpgrade(configuration: ForceUpgradeConfiguration): configuration is SkippableUpgrade {
  return configuration.type === ForceUpgradeType.Skippable;
}

export function isServiceTerminated(configuration: DeviceConfiguration) {
  return configuration.ebox && configuration.ebox.isMigrationEnabled && configuration.ebox.isServerTerminated;
}
